<template>
  <div
    class="content-slide-ppt-wrp"
    :class="{'hidden': isWhiteLabel}"
  >
    <div class="bg-white-100 flex rounded-lg justify-center  items-center ">
      <div class="mr-1 my-1" v-if="canUseAIImproveDirectly">
        <ImproveWritingDropDown />
      </div>
      <div class="divider" v-if="canUseAIImproveDirectly" />
      <div
        v-if="!isWhiteLabel && !isZoomReady"
        class="ppt-add-in__button"
        v-tooltip="{
          content: tooltip,
          show: isShowTooltip,
        }"
        @mouseover="hoverTooltipHandler()"
        @mouseleave="leaveTooltipHandle()"
        @click="openPPTModal"
      >
        <div class="ppt-add-in__button-content">
          <aha-icon
            name="ppt-add-in"
            width="20"
            height="20"
            viewBox="0 0 16 16"
            maintainColor
          />
          <span class="ml-1">{{ $i18nPresenter.t('Add to PowerPoint') }}</span>
        </div>
      </div>
      <AddInPPTModal
        v-if="showModalPPT"
        @hide="hidePPTModal"
        @done="donePPTModal"
        :slideType="slideType"
        :type="type"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import AddInPPTModal from '@/components-v2/modals/AddInPPTModal.vue'
import Util from '@/util'
import constants from '@/constant'
import ImproveWritingDropDown from '@/components-v2/presentation-editor/freestyle/ImproveWritingDropDown.vue'

const { eventCategories } = constants

export default {
  components: {
    AddInPPTModal,
    ImproveWritingDropDown,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    slideType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showModalPPT: false,
      tooltip: '',
      isShowTooltip: false,
    }
  },
  computed: {
    ...mapGetters('zoomApp', ['isZoomReady']),
    ...mapGetters('aiAutoImproveSlideContent', ['canUseAIImproveDirectly']),
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    isWhiteLabel() {
      return Util.checkWhiteLabelDomain()
    },
  },
  watch: {
    '$store.state.slideActive': {
      handler(newVal) {
        const { type, slideType } = newVal
        const slideName = Util.getCorrectSlideTypeName(type, slideType)
        const tooltipName = {
          poll: 'Poll',
          pickAnswer: 'Quiz',
          wordCloud: 'Word Cloud',
          pickImage: 'Quiz',
          'q&a': 'Q&A',
          leaderboard: 'Leaderboard',
          spinnerWheel: 'Spinner Wheel',
        }
        if (tooltipName[slideName]) {
          const text = this.getTooltipLocalizeText(tooltipName[slideName])
          this.tooltip = `<div>
            <div>
              <span style="font-family: 'Nunito';"><b>${text}</b></span>
            </div>
            </div>`
        } else {
          this.tooltip = ''
        }
      },
      immediate: true,
    },
    $route: {
      handler(to) {
        const { presenting = false, preview = false } = to.query
        if (presenting || preview) {
          this.tooltip = ''
        }
      },
    },
  },
  mounted() {
    this.showModalPPT = false
  },
  methods: {
    getTooltipLocalizeText(name) {
      const text = `Run this ${name} in PowerPoint!`
      if (this.$i18nPresenter) {
        return this.$i18nPresenter.t('runThisXInPowerPoint', {
          name,
        })
      }
      return text
    },
    openPPTModal() {
      this.showModalPPT = true
      const slideName = Util.getCorrectSlideTypeName(this.type, this.slideType)
      Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Open modal', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    hidePPTModal() {
      this.showModalPPT = false
      const slideName = Util.getCorrectSlideTypeName(this.type, this.slideType)
      Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Close modal', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    donePPTModal() {
      this.showModalPPT = false
      const slideName = Util.getCorrectSlideTypeName(this.type, this.slideType)
      Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Done', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    hoverTooltipHandler() {
      this.isShowTooltip = true
    },
    leaveTooltipHandle() {
      this.isShowTooltip = false
    },
  },
}
</script>

<style lang="scss" scoped>
.content-slide-ppt-wrp {
  display: flex;
  @apply items-center justify-center rounded-lg my-3;
  &.hidden {
    margin-top: 60px;
  }
}
.ppt-add-in__button {
  @apply bg-base-0;
  @apply whitespace-nowrap w-max p-1;
  @apply cursor-pointer;
  border-radius: 0.5rem;
  &:hover, &:active {
    .ppt-add-in__button-content {
      @apply bg-secondary-15;
    }
  }
  .ppt-add-in__button-content {
    display: flex;
    align-items: center;
    @apply p-1 rounded;
  }
}
.divider{
  width: 1px;
  background: #D3D7E1;
  height: 18px;
  margin-right: 4px;
  margin-left: 6px;
}
</style>
